export default __webpack_public_path__ + "static/media/notfound.e99291f6.jpg";